import React, { useContext } from "react";
import GithubContext from "../../context/github/githubContext";
import RepoCard from "../repos/RepoCard";
import Pagination from "../ui/Pagination";
import ResultsToolbar from "./ResultsToolbar";

const SkeletonGrid = () => (
  <div className="gf-repo-grid">
    {[1, 2, 3, 4, 5, 6].map((k) => (
      <div key={k} className="gf-skeleton gf-skeleton--repo-card" />
    ))}
  </div>
);

const RepoResultsSection = ({ keyword, onPageChange, sortValue, onSortChange }) => {
  const { repoResults, repoSearchLoading, repoSearchMeta } =
    useContext(GithubContext);

  const perPage = repoSearchMeta?.perPage || 12;
  const page = repoSearchMeta?.page || 1;
  const total = repoSearchMeta?.total ?? 0;

  if (repoSearchLoading && (!repoResults || repoResults.length === 0)) {
    return (
      <section className="gf-results" aria-labelledby="repo-results-heading">
        <h2 id="repo-results-heading" className="gf-section-title">
          Repositories
        </h2>
        <SkeletonGrid />
      </section>
    );
  }

  if (!repoResults || repoResults.length === 0) {
    return null;
  }

  return (
    <section className="gf-results" aria-labelledby="repo-results-heading">
      <h2 id="repo-results-heading" className="gf-section-title">
        Repositories
      </h2>
      <ResultsToolbar
        mode="repositories"
        keyword={keyword}
        total={total}
        page={page}
        perPage={perPage}
        sortValue={sortValue}
        onSortChange={onSortChange}
      />
      <div className="gf-repo-grid">
        {repoResults.map((repo) => (
          <RepoCard key={repo.id} repo={repo} />
        ))}
      </div>
      <Pagination
        page={page}
        total={total}
        perPage={perPage}
        onPageChange={(p) => onPageChange(p)}
        disabled={repoSearchLoading}
        aria-label="Repository results pagination"
      />
      {repoSearchLoading && (
        <p className="gf-muted gf-results__loading">Updating…</p>
      )}
    </section>
  );
};

export default RepoResultsSection;
